/*eslint-disable */

import Vue from "vue";
import axios from 'axios';
import root from '../_helpers/roots';

let schedulerApiUrl = root.schedulerApiUrl.link;
let newSchedulerApiUrl = root.newSchedulerApiUrl.link;
export default {
  state: {
    getSchedulerListState:{},
  },
  mutations: {
    getSchedulerListMut(state, value) {
      Vue.set(state, 'getSchedulerListState', value);
    },
  },
  actions: {
    // scheduler Create Data Method
    createSchedulerDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(schedulerApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // scheduler Remove From List Method
    removeSchedulerDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(newSchedulerApiUrl + '?Id=' + payload.id).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // scheduler Update Info Method
    updateSchedulerDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(newSchedulerApiUrl + '?Id=' + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // get Scheduler List Method
    getSchedulerListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(schedulerApiUrl).then(res => {
              context.commit('getSchedulerListMut', res.data.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // get Scheduler List Method
    getSchedulerListByDateAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(schedulerApiUrl + '?start_date_time=' + payload.Date).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getSchedulerListGetter: state => state.getSchedulerListState,
  }
}